export default __webpack_public_path__ + "static/media/T6-output.595ee757.png";